// extracted by mini-css-extract-plugin
export default {"UpdateProviderConfigModalDialog":"UpdateProviderConfigModalDialog_UpdateProviderConfigModalDialog__AFTyj"};